export class MenuConfig {
	public defaults: any = {
		header: {
			self: {},
			items: [
				{
					title: "Dashboards",
					root: true,
					alignment: "left",
					page: "/dashboard",
					translate: "MENU.DASHBOARD",
					pageCode: "DH",
				},
			],
		},
		aside: {
			self: {},
			items: [
				// {
				// 	title: 'Dashboard',
				// 	root: true,
				// 	icon: 'fas fa-home',
				// 	page: '/admin-dashboard',
				// 	translate: 'MENU.DASHBOARD',
				// 	bullet: 'dot',
				// 	pageCode: 'AD',
				// 	allwoed: false,
				// },
				{
					title: "Dashboard",
					root: true,
					icon: "fas fa-home",
					page: "/dashboard",
					translate: "MENU.DASHBOARD",
					bullet: "dot",
					pageCode: "DH",
					allwoed: false,
				},


				{
					title: "LAW GRADUATES SCHOLARSHIP PROGRAM",
					root: true,
					icon: "fas fa-book-open",
					page: "/lgsp",
					translate: "MENU.DASHBOARD",
					bullet: "dot",
					pageCode: "LGSP",
					allwoed: true,
				},
				{
					title: "US-PAKISTAN KNOWLEDGE CORRIDOR APPLICATION FORM",
					root: true,
					icon: "fas fa-book-open",
					page: "/puca-app/Application-Form",
					translate: "MENU.DASHBOARD",
					bullet: "dot",
					pageCode: "DH",
					allwoed: false,
				},
				{
					title: "Faculty Development Program for Pakistani Universities",
					root: true,
					icon: "fas fa-book-open",
					page: "/fdp-app",
					translate: "MENU.DASHBOARD",
					bullet: "dot",
					pageCode: "FDP",
					allwoed: true,
				},
				{
					title: "ANNOUNCEMENTS",
					root: true,
					icon: "fas fa-bullhorn",
					page: "/announcements/announcements",
					translate: "MENU.DASHBOARD",
					bullet: "dot",
					allwoed: true,
					pageCode: "merits",
				},
				// {
				// 	title: 'USAID-funded Merit and Needs Based Scholarship Program',
				// 	root: true,
				// 	icon: 'fas fa-book-open',
				// 	page: '/usaid',
				// 	translate: 'MENU.DASHBOARD',
				// 	bullet: 'dot',
				// 	allwoed: true,
				// 	pageCode: 'merits'
				// },
				{
					title: "Balochistan/FATA (Phase-III), Undergraduate Scholarships",
					root: true,
					icon: "fas fa-book-open",
					page: "/bfap-app",
					translate: "MENU.DASHBOARD",
					bullet: "dot",
					pageCode: "Bal",
					allwoed: true,
				},
				{
					title: "Learning Opportunities Abroad",
					root: true,
					icon: "fas fa-book-open",
					page: "/loa",
					translate: "MENU.DASHBOARD",
					bullet: "dot",
					allwoed: true,
					pageCode: "merits",
				},
				{
					title: "Overseas Scholarships for PhD & MS/Mphil",
					root: true,
					icon: "fas fa-book-open",
					page: "/osp",
					translate: "MENU.DASHBOARD",
					bullet: "dot",
					allwoed: true,
					pageCode: "OFSP",
				},
				{
					title: "Pak Srilanka Scholarship Program",
					root: true,
					icon: "fas fa-book-open",
					page: "/psl",
					translate: "MENU.DASHBOARD",
					bullet: "dot",
					allwoed: true,
					pageCode: "merits",
				},
				{
					title: "Pak Bangladesh Scholarship Program",
					root: true,
					icon: "fas fa-book-open",
					page: "/pbs",
					translate: "MENU.DASHBOARD",
					bullet: "dot",
					allwoed: true,
					pageCode: "merits",
				},
				{
					title: "Central Asia & friendly countries",
					root: true,
					icon: "fas fa-book-open",
					page: "/cafc",
					translate: "MENU.DASHBOARD",
					bullet: "dot",
					allwoed: true,
					pageCode: "merits",
				},
				{
					title: "Semester Exchange Scholarship",
					root: true,
					icon: "fas fa-book-open",
					page: "/sesp",
					translate: "MENU.DASHBOARD",
					bullet: "dot",
					allwoed: true,
					pageCode: "SESP",
				},
				{
					title: "Prime Minister Wheelchair Program",
					root: true,
					icon: "fas fa-wheelchair",
					page: "/wcp",
					translate: "MENU.DASHBOARD",
					bullet: "dot",
					allwoed: true,
					pageCode: "WCP",
				},
				{
					title: "Hungarian Scholarship Program",
					root: true,
					icon: "fas fa-book-open",
					page: "/hsp",
					translate: "MENU.DASHBOARD",
					bullet: "dot",
					allwoed: true,
					pageCode: "merits",
				},
				{
					title: "International Research Support Initiative Program",
					root: true,
					icon: "fas fa-book-open",
					page: "/irsip-app/Application-Form",
					translate: "MENU.DASHBOARD",
					bullet: "dot",
					pageCode: "DH",
					allwoed: false,
				},
				{
					title: "Interim placement of Fresh PHDs",
					root: true,
					icon: "fas fa-book-open",
					page: "/ipfp-app/Application-Form",
					translate: "MENU.DASHBOARD",
					bullet: "dot",
					pageCode: "DH",
					allwoed: false,
				},
				{
					title: "Coastal Region Higher Education Scholarship Program For Balochistan",
					root: true,
					icon: "fas fa-book-open",
					page: "/crhespb",
					translate: "MENU.DASHBOARD",
					bullet: "dot",
					pageCode: "CRHESPB",
					allwoed: true,
				},
				{
					title: "ANNOUNCEMENT OF INDIGENOUS PHASE-II BATCH-VI MERIT",
					root: true,
					icon: "fas fa-bullhorn",
					page: "/indigenous/i5000",
					translate: "MENU.DASHBOARD",
					bullet: "dot",
					pageCode: "I5000",
					allwoed: false,
				},
				// {
				// 	title: 'Shortlisting',
				// 	root: true,
				// 	alignment: 'left',
				// 	page: '/admin-dashboard/shortlisting',
				// 	icon: 'far fa-user',
				// 	pageCode: 'AD',
				// 	translate: 'MENU.DASHBOARD',
				// 	bullet: 'dot',
				// 	allwoed: false,
				// },
				// {
				// 	title: 'Configuration',
				// 	root: true,
				// 	alignment: 'left',
				// 	page: '/admin-dashboard/configuration',
				// 	icon: 'fa fa-power-off',
				// 	pageCode: 'AD',
				// 	translate: 'MENU.DASHBOARD',
				// 	bullet: 'dot',
				// 	allwoed: false,
				// },
			],
		},
	};

	public get configs(): any {
		return this.defaults;
	}
}
